import { useEffect, useState } from 'react'
import { API_URL, getClassNameForField, projectJourneyFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useTranslationService } from '../../util/TranslationContext'
import { languageUtil } from '../../util/languageUtils'

const ProjectJourneyCreate = () => {
    const [options, setOptions] = useState([])

    const { translateFields } = useTranslationService()
    const projectJourneyFields = translateFields(fields, 'project_journeys')
    const { language } = languageUtil()

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const token = localStorage.getItem('token')
                const response = await fetch(`${API_URL}/admin/projects`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Accept-Language': language,
                    },
                })
                const result = await response.json()

                // Assuming response.data.data is the array of categories
                const mappedOptions = result.data.map(item => ({
                    label: item.title,
                    value: item.id,
                }))
                setOptions(mappedOptions)
            } catch (error) {
                console.error('Error fetching options:', error)
            }
        }

        fetchOptions()
    }, [language])

    return (
        <>
            <EditableFormPage
                submitUrl='admin/project-journeys'
                fields={projectJourneyFields}
                classNameForField={getClassNameForField}
                create={true}
                options={options}
                navigateLink='/admin/auth/project-journeys'
            />
        </>
    )
}

export default ProjectJourneyCreate
